import * as React from "react";

import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  BooleanInput,
  ReferenceArrayInput,
  SelectArrayInput,
  FormDataConsumer,
  useDataProvider,
  useNotify,
  useRefresh,
  useRecordContext,
} from "react-admin";
import { Button, Stack, Box } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import { useClub } from "../club/ClubContext";

function SyncNowButton() {
  const record = useRecordContext<any>();
  const dp = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const feedId = record?.id;

  return (
    <Button
      variant="contained"
      startIcon={<SyncIcon />}
      disabled={!feedId}
      onClick={async () => {
        try {
          await (dp as any).custom(`calendar-feeds/${feedId}/sync`, { method: "POST" });
          notify("Sync angestoßen.", { type: "info" });
          refresh();
        } catch (e: any) {
          notify(e?.message ?? "Sync fehlgeschlagen", { type: "warning" });
        }
      }}
    >
      Sync jetzt
    </Button>
  );
}

export function CalendarFeedEdit(props: any) {
  const { clubId } = useClub();
  const dp = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Edit
      {...props}
      transform={(data: any) => ({
        ...data,
        club_id: clubId,
        team_ids: data.scope === "TEAMS" ? (data.team_ids ?? []) : [],
      })}
    >
      <SimpleForm>
        <Box sx={{ mb: 3 }}>
          <SyncNowButton />
        </Box>

        <TextInput source="name" label="Name" validate={required()} fullWidth />
        <TextInput source="url_https" label="ICS URL (https)" validate={required()} fullWidth />

        <SelectInput
          source="scope"
          label="Sichtbarkeit"
          choices={[
            { id: "ALL_CLUB", name: "Alle im Verein" },
            { id: "TEAMS", name: "Nur bestimmte Teams" },
          ]}
          fullWidth
        />

        <SelectInput
          source="sync_mode"
          label="Modus"
          choices={[
            { id: "SUBSCRIBE_ONLY", name: "Nur abonnieren" },
            { id: "IMPORT_ONLY", name: "Nur importieren" },
            { id: "SUBSCRIBE_AND_IMPORT", name: "Abonnieren + Import" },
          ]}
          fullWidth
        />

        <FormDataConsumer>
          {({ formData }) =>
            formData?.scope === "TEAMS" ? (
              <ReferenceArrayInput
                source="team_ids"
                reference="teams"
                label="Teams"
                filter={clubId ? { clubId } : {}}
              >
                <SelectArrayInput optionText="name" />
              </ReferenceArrayInput>
            ) : null
          }
        </FormDataConsumer>

        <BooleanInput source="is_active" label="Aktiv" />
        <TextInput source="last_error" label="Letzter Fehler" fullWidth disabled />
      </SimpleForm>
    </Edit>
  );
}
